import { ReactNode } from 'react';
import SharedSvg from './shared-svg';
import { SxProps, Theme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Close from '@mui/icons-material/Close';

interface SimpleDrawerProps {
  title: string;
  children: ReactNode;
  width?: number | string;
  sx?: SxProps<Theme>;
  onClose?: () => void;
  isLoading?: boolean;
  headerActions?: ReactNode;
}

export default function SimpleDrawer({
  title,
  children,
  sx,
  onClose,
  isLoading,
  headerActions,
}: SimpleDrawerProps) {
  if (isLoading) {
    return (
      <Stack
        sx={{ width: '100%', height: '100%', ...sx }}
        justifyContent="center"
        alignItems="center"
      >
        <CircularProgress />
      </Stack>
    );
  }

  return (
    <Box
      sx={{
        width: '100%',
        p: 3,
        height: '100%',
        ...sx,
      }}
    >
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        sx={{ mb: 2 }}
      >
        <Stack direction="row" spacing={1.5} alignItems="center">
          <SharedSvg />
          <Typography variant="h5" sx={{ fontWeight: 400 }}>
            {title}
          </Typography>
        </Stack>
        {(headerActions || onClose) && (
          <Stack direction="row" alignItems="center">
            {headerActions}
            {onClose && (
              <IconButton onClick={onClose}>
                <Close />
              </IconButton>
            )}
          </Stack>
        )}
      </Stack>
      <Divider sx={{ mb: 2 }} />
      <Box sx={{ height: 'calc(100% - 74px)', overflowY: 'auto' }}>
        {children}
      </Box>
    </Box>
  );
}
